var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { fullScreen$, resize$ } from "../../../../events/eventsBrowser";
import { IdStyles } from "../../../../less/IdStyles";
import { selectBuildingInfoByTypeId } from "../../../../selectors/selectExistingBuildingInfo";
import { selectActiveTutorialConfig } from "../../../../selectors/selectTutorial";
import { utilSVG } from "../../../../utils/svg/utilSVG";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { BouncingArrow } from "../../../generic/common/BouncingArrow";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { ViewportWorldSpace } from "../../../viewport/ViewportWorldSpace";
import { TutorialBackground } from "../TutorialBackground";
import { TutorialBlockInputs } from "../TutorialBlockInputs";
import { TutorialCharacterHelper } from "../TutorialCharacterHelper";
var TutorialFocusOnCanvasDOM = /** @class */ (function (_super) {
    __extends(TutorialFocusOnCanvasDOM, _super);
    function TutorialFocusOnCanvasDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderContent = function (viewport) {
            var tutorialConfig = _this.props.tutorialConfig;
            var _a = _this.getRenderParams(viewport), arrowStyle = _a.arrowStyle, backgroundRect = _a.backgroundRect, contentStyle = _a.contentStyle, ellipsePath = _a.ellipsePath;
            return (React.createElement("div", null,
                React.createElement(TutorialBackground, { rect: backgroundRect, ellipsePath: ellipsePath }),
                tutorialConfig.idLocaDescription && (React.createElement("div", { className: "flex flex--centered", style: contentStyle },
                    React.createElement(TutorialCharacterHelper, { locaDescription: tutorialConfig.idLocaDescription }))),
                tutorialConfig.nextStep && !tutorialConfig.hideArrow && (React.createElement(BouncingArrow, { icon: IdIcon.RedArrowIcn, iconStyle: IdStyles.IconExtraLarge, containerCSSProps: arrowStyle }))));
        };
        _this.getRenderParams = function (viewport) {
            var _a = _this.props, tutorialConfig = _a.tutorialConfig, focusBuilding = _a.focusBuilding;
            var buildingDimensions = utilBuildings.getBuildingDimensions(focusBuilding);
            var rootPosition = utilBuildings.getCenterPositionOnScreen(focusBuilding, viewport);
            var contentStyle = {
                left: 50 + "%",
                position: "absolute",
                top: tutorialConfig.descriptionTopPosition + "%",
            };
            var backgroundRect = {
                bottom: window.innerHeight - rootPosition.x,
                height: buildingDimensions.height,
                left: rootPosition.x,
                right: window.innerWidth - rootPosition.y,
                top: rootPosition.y - buildingDimensions.height * 0.2,
                width: buildingDimensions.width,
            };
            var arrowStyle = {
                animationName: tutorialConfig.arrowAnimation,
                left: rootPosition.x + buildingDimensions.width * 0.2 + "px",
                top: rootPosition.y - buildingDimensions.height * 0.8 + "px",
            };
            var ellipsePath = utilSVG.rectToPixiEllipseToPath(backgroundRect, 0.4, 10);
            return {
                arrowStyle: arrowStyle,
                backgroundRect: backgroundRect,
                contentStyle: contentStyle,
                ellipsePath: ellipsePath,
            };
        };
        _this.onResize = function () {
            _this.setState({});
        };
        return _this;
    }
    TutorialFocusOnCanvasDOM.prototype.componentDidMount = function () {
        this.resizeSubscription$ = resize$.subscribe(this.onResize);
        this.fullScreen$ = fullScreen$.subscribe(this.onResize);
    };
    TutorialFocusOnCanvasDOM.prototype.componentWillUnmount = function () {
        this.resizeSubscription$.unsubscribe();
        this.fullScreen$.unsubscribe();
    };
    TutorialFocusOnCanvasDOM.prototype.render = function () {
        var _this = this;
        var _a = this.props, tutorialConfig = _a.tutorialConfig, focusBuilding = _a.focusBuilding;
        return tutorialConfig && focusBuilding ? (React.createElement(ViewportWorldSpace, null, function (viewport) { return _this.renderContent(viewport); })) : (React.createElement(TutorialBlockInputs, null));
    };
    return TutorialFocusOnCanvasDOM;
}(React.Component));
var mapState = function (state) {
    var tutorialConfig = selectActiveTutorialConfig(state);
    var focusBuilding;
    if (tutorialConfig && tutorialConfig.buildingId) {
        focusBuilding = selectBuildingInfoByTypeId(state, tutorialConfig.buildingId);
    }
    return {
        focusBuilding: focusBuilding,
        tutorialConfig: tutorialConfig,
    };
};
export var TutorialFocusOnCanvas = connect(mapState, undefined)(TutorialFocusOnCanvasDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/tutorial-canvas/TutorialFocusOnCanvas.tsx
// module id = 1140
// module chunks = 3